import { useState } from 'react'
import type { FormEvent } from 'react'
import { ApiError } from '../api/client'
import { submitB2bInquiry } from '../api/inquiries'
import {
  CORPORATE_ENQUIRY_COPY,
  EMPTY_CORPORATE_ENQUIRY,
  type B2bRequirementKey,
  type CorporateEnquiryForm,
  type UseInquiryFormResult,
} from '../constants/inquiries'
import {
  b2bInquiryPayload,
  toggleRequirement,
  validateCorporateEnquiry,
} from '../helpers/inquiries'

export function useCorporateEnquiryForm(): UseInquiryFormResult<CorporateEnquiryForm> & {
  toggleRequirement: (id: B2bRequirementKey) => void
} {
  const [form, setForm] = useState<CorporateEnquiryForm>(EMPTY_CORPORATE_ENQUIRY)
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState<string | null>(null)

  function update(patch: Partial<CorporateEnquiryForm>) {
    setForm((current) => ({ ...current, ...patch }))
  }

  function onToggleRequirement(id: B2bRequirementKey) {
    setForm((current) => ({
      ...current,
      requirements: toggleRequirement(current.requirements, id),
    }))
  }

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    const message = validateCorporateEnquiry(form)
    if (message) {
      setError(message)
      return
    }
    setSubmitting(true)
    setError(null)
    try {
      await submitB2bInquiry(b2bInquiryPayload(form))
      setSubmitted(true)
    } catch (err) {
      setError(
        err instanceof ApiError ? err.message : CORPORATE_ENQUIRY_COPY.error,
      )
    } finally {
      setSubmitting(false)
    }
  }

  return {
    form,
    update,
    submitting,
    submitted,
    error,
    onSubmit,
    toggleRequirement: onToggleRequirement,
  }
}
